function htmlSetIframeDataSrcAttributes(html, fallbackUrl) {
  return html.replace(/<iframe/g, `<iframe data-src="${fallbackUrl}" `);
}

export {
  htmlSetIframeDataSrcAttributes,
};
